// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__24-4a","choiceBoxes":"toolbarselects_choiceBoxes__4l-p9","simpleField":"toolbarselects_simpleField__1u14g"};